(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5624,6136,152],{

/***/ 93946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IconButton_IconButton; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 6 modules
var ButtonBase = __webpack_require__(82607);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/IconButton/iconButtonClasses.js


function getIconButtonUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiIconButton', slot);
}
const iconButtonClasses = (0,generateUtilityClasses/* default */.Z)('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
/* harmony default export */ var IconButton_iconButtonClasses = (iconButtonClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
'use client';



const _excluded = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];












const useUtilityClasses = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${(0,capitalize/* default */.Z)(color)}`, edge && `edge${(0,capitalize/* default */.Z)(edge)}`, `size${(0,capitalize/* default */.Z)(size)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getIconButtonUtilityClass, classes);
};
const IconButtonRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], ownerState.edge && styles[`edge${(0,capitalize/* default */.Z)(ownerState.edge)}`], styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: (theme.vars || theme).palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  })
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => {
  var _palette;
  const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
  return (0,esm_extends/* default */.Z)({}, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0,esm_extends/* default */.Z)({
    color: palette == null ? void 0 : palette.main
  }, !ownerState.disableRipple && {
    '&:hover': (0,esm_extends/* default */.Z)({}, palette && {
      backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(palette.main, theme.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    })
  }), ownerState.size === 'small' && {
    padding: 5,
    fontSize: theme.typography.pxToRem(18)
  }, ownerState.size === 'large' && {
    padding: 12,
    fontSize: theme.typography.pxToRem(28)
  }, {
    [`&.${IconButton_iconButtonClasses.disabled}`]: {
      backgroundColor: 'transparent',
      color: (theme.vars || theme).palette.action.disabled
    }
  });
});

/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */
const IconButton = /*#__PURE__*/react.forwardRef(function IconButton(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiIconButton'
  });
  const {
      edge = false,
      children,
      className,
      color = 'default',
      disabled = false,
      disableFocusRipple = false,
      size = 'medium'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButtonRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other, {
    ownerState: ownerState,
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var IconButton_IconButton = (IconButton);

/***/ }),

/***/ 18987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ListItemAvatar_ListItemAvatar; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/ListContext.js
var ListContext = __webpack_require__(59773);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListItemAvatar/listItemAvatarClasses.js


function getListItemAvatarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiListItemAvatar', slot);
}
const listItemAvatarClasses = (0,generateUtilityClasses/* default */.Z)('MuiListItemAvatar', ['root', 'alignItemsFlexStart']);
/* harmony default export */ var ListItemAvatar_listItemAvatarClasses = ((/* unused pure expression or super */ null && (listItemAvatarClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js
'use client';



const _excluded = ["className"];









const useUtilityClasses = ownerState => {
  const {
    alignItems,
    classes
  } = ownerState;
  const slots = {
    root: ['root', alignItems === 'flex-start' && 'alignItemsFlexStart']
  };
  return (0,composeClasses/* default */.Z)(slots, getListItemAvatarUtilityClass, classes);
};
const ListItemAvatarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiListItemAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  minWidth: 56,
  flexShrink: 0
}, ownerState.alignItems === 'flex-start' && {
  marginTop: 8
}));

/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */
const ListItemAvatar = /*#__PURE__*/react.forwardRef(function ListItemAvatar(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiListItemAvatar'
  });
  const {
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const context = react.useContext(ListContext/* default */.Z);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    alignItems: context.alignItems
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemAvatarRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var ListItemAvatar_ListItemAvatar = (ListItemAvatar);

/***/ }),

/***/ 98619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export overridesResolver */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63961);
/* harmony import */ var _mui_utils_composeClasses__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _mui_system_colorManipulator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2101);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90948);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14136);
/* harmony import */ var _DefaultPropsProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28628);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82607);
/* harmony import */ var _utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58974);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51705);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59773);
/* harmony import */ var _listItemButtonClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68686);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected", "className"];













const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};
const useUtilityClasses = ownerState => {
  const {
    alignItems,
    classes,
    dense,
    disabled,
    disableGutters,
    divider,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', divider && 'divider', disabled && 'disabled', alignItems === 'flex-start' && 'alignItemsFlexStart', selected && 'selected']
  };
  const composedClasses = (0,_mui_utils_composeClasses__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _listItemButtonClasses__WEBPACK_IMPORTED_MODULE_3__/* .getListItemButtonUtilityClass */ .t, classes);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, classes, composedClasses);
};
const ListItemButtonRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_ButtonBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
  shouldForwardProp: prop => (0,_styles_styled__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(prop) || prop === 'classes',
  name: 'MuiListItemButton',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  minWidth: 0,
  boxSizing: 'border-box',
  textAlign: 'left',
  paddingTop: 8,
  paddingBottom: 8,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${_listItemButtonClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].selected */ .Z.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,_mui_system_colorManipulator__WEBPACK_IMPORTED_MODULE_8__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${_listItemButtonClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].focusVisible */ .Z.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0,_mui_system_colorManipulator__WEBPACK_IMPORTED_MODULE_8__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${_listItemButtonClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].selected */ .Z.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0,_mui_system_colorManipulator__WEBPACK_IMPORTED_MODULE_8__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,_mui_system_colorManipulator__WEBPACK_IMPORTED_MODULE_8__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${_listItemButtonClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].focusVisible */ .Z.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${_listItemButtonClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].disabled */ .Z.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}));
const ListItemButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemButton(inProps, ref) {
  const props = (0,_DefaultPropsProvider__WEBPACK_IMPORTED_MODULE_9__/* .useDefaultProps */ .i)({
    props: inProps,
    name: 'MuiListItemButton'
  });
  const {
      alignItems = 'center',
      autoFocus = false,
      component = 'div',
      children,
      dense = false,
      disableGutters = false,
      divider = false,
      focusVisibleClassName,
      selected = false,
      className
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(props, _excluded);
  const context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z);
  const childContext = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  }), [alignItems, context.dense, dense, disableGutters]);
  const listItemRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  (0,_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props, {
    alignItems,
    dense: childContext.dense,
    disableGutters,
    divider,
    selected
  });
  const classes = useUtilityClasses(ownerState);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(listItemRef, ref);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_List_ListContext__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Provider */ .Z.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItemButtonRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      ref: handleRef,
      href: other.href || other.to
      // `ButtonBase` processes `href` or `to` if `component` is set to 'button'
      ,
      component: (other.href || other.to) && component === 'div' ? 'button' : component,
      focusVisibleClassName: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.focusVisible, focusVisibleClassName),
      ownerState: ownerState,
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.root, className)
    }, other, {
      classes: classes,
      children: children
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (ListItemButton);

/***/ }),

/***/ 59334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63961);
/* harmony import */ var _mui_utils_composeClasses__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46483);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59773);
/* harmony import */ var _DefaultPropsProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28628);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _listItemTextClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26336);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"];











const useUtilityClasses = ownerState => {
  const {
    classes,
    inset,
    primary,
    secondary,
    dense
  } = ownerState;
  const slots = {
    root: ['root', inset && 'inset', dense && 'dense', primary && secondary && 'multiline'],
    primary: ['primary'],
    secondary: ['secondary']
  };
  return (0,_mui_utils_composeClasses__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _listItemTextClasses__WEBPACK_IMPORTED_MODULE_3__/* .getListItemTextUtilityClass */ .L, classes);
};
const ListItemTextRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)('div', {
  name: 'MuiListItemText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_listItemTextClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary}`]: styles.primary
    }, {
      [`& .${_listItemTextClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].secondary */ .Z.secondary}`]: styles.secondary
    }, styles.root, ownerState.inset && styles.inset, ownerState.primary && ownerState.secondary && styles.multiline, ownerState.dense && styles.dense];
  }
})(({
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  flex: '1 1 auto',
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, ownerState.primary && ownerState.secondary && {
  marginTop: 6,
  marginBottom: 6
}, ownerState.inset && {
  paddingLeft: 56
}));
const ListItemText = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemText(inProps, ref) {
  const props = (0,_DefaultPropsProvider__WEBPACK_IMPORTED_MODULE_6__/* .useDefaultProps */ .i)({
    props: inProps,
    name: 'MuiListItemText'
  });
  const {
      children,
      className,
      disableTypography = false,
      inset = false,
      primary: primaryProp,
      primaryTypographyProps,
      secondary: secondaryProp,
      secondaryTypographyProps
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, _excluded);
  const {
    dense
  } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z);
  let primary = primaryProp != null ? primaryProp : children;
  let secondary = secondaryProp;
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, {
    disableTypography,
    inset,
    primary: !!primary,
    secondary: !!secondary,
    dense
  });
  const classes = useUtilityClasses(ownerState);
  if (primary != null && primary.type !== _Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z && !disableTypography) {
    primary = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
      display: "block"
    }, primaryTypographyProps, {
      children: primary
    }));
  }
  if (secondary != null && secondary.type !== _Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z && !disableTypography) {
    secondary = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
      variant: "body2",
      className: classes.secondary,
      color: "text.secondary",
      display: "block"
    }, secondaryTypographyProps, {
      children: secondary
    }));
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListItemTextRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [primary, secondary]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (ListItemText);

/***/ }),

/***/ 41796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "_j": function() { return /* binding */ darken; }
/* harmony export */ });
/* unused harmony exports hexToRgb, decomposeColor, colorChannel, private_safeColorChannel, recomposeColor, rgbToHex, hslToRgb, getLuminance, getContrastRatio, alpha, private_safeAlpha, private_safeDarken, private_safeLighten, emphasize, private_safeEmphasize, blend */
/* harmony import */ var _mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56535);
/* harmony import */ var _mui_utils_clamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7610);

/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value, min = 0, max = 1) {
  if (false) {}
  return (0,_mui_utils_clamp__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error( false ? 0 : (0,_mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const backgroundColor = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: 'rgb',
    values: rgb
  });
}

/***/ }),

/***/ 99589:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facebook",
      function () {
        return __webpack_require__(77332);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 92024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69661);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41796);
/* harmony import */ var src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19550);
// ** React Imports


// ** MUI Imports


// ** Hooks Imports

const Avatar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    // ** Props
    const { sx , src , skin , color  } = props;
    // ** Hook
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const bgColors = (0,src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const getAvatarStyles = (skin, skinColor)=>{
        let avatarStyles;
        if (skin === "light") {
            avatarStyles = {
                ...bgColors["".concat(skinColor, "Light")]
            };
        } else if (skin === "light-static") {
            avatarStyles = {
                color: bgColors["".concat(skinColor, "Light")].color,
                backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* .lighten */ .$n)(theme.palette[skinColor].main, 0.88)
            };
        } else {
            avatarStyles = {
                ...bgColors["".concat(skinColor, "Filled")]
            };
        }
        return avatarStyles;
    };
    const colors = {
        primary: getAvatarStyles(skin, "primary"),
        secondary: getAvatarStyles(skin, "secondary"),
        success: getAvatarStyles(skin, "success"),
        error: getAvatarStyles(skin, "error"),
        warning: getAvatarStyles(skin, "warning"),
        info: getAvatarStyles(skin, "info")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        ref: ref,
        ...props,
        sx: !src && skin && color ? Object.assign(colors[color], sx) : sx
    });
});
Avatar.defaultProps = {
    skin: "filled",
    color: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 66136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SettingsConsumer": function() { return /* binding */ SettingsConsumer; },
/* harmony export */   "SettingsContext": function() { return /* binding */ SettingsContext; },
/* harmony export */   "SettingsProvider": function() { return /* binding */ SettingsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30152);
// ** React Imports


// ** ThemeConfig Import

const initialSettings = {
    themeColor: "primary",
    mode: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].mode,
    skin: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].skin,
    footer: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].footer,
    layout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    lastLayout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    direction: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].direction,
    navHidden: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navHidden,
    appBarBlur: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBarBlur,
    navCollapsed: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navCollapsed,
    contentWidth: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].contentWidth,
    toastPosition: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].toastPosition,
    verticalNavToggleType: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].verticalNavToggleType,
    appBar: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout === "horizontal" && src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar === "hidden" ? "fixed" : src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar
};
const staticSettings = {
    appBar: initialSettings.appBar,
    footer: initialSettings.footer,
    layout: initialSettings.layout,
    navHidden: initialSettings.navHidden,
    lastLayout: initialSettings.lastLayout,
    toastPosition: initialSettings.toastPosition
};
const restoreSettings = ()=>{
    let settings = null;
    try {
        const storedData = window.localStorage.getItem("settings");
        if (storedData) {
            settings = {
                ...JSON.parse(storedData),
                ...staticSettings
            };
        } else {
            settings = initialSettings;
        }
    } catch (err) {
        ;
    }
    return settings;
};
// set settings in localStorage
const storeSettings = (settings)=>{
    const initSettings = Object.assign({}, settings);
    delete initSettings.appBar;
    delete initSettings.footer;
    delete initSettings.layout;
    delete initSettings.navHidden;
    delete initSettings.lastLayout;
    delete initSettings.toastPosition;
    window.localStorage.setItem("settings", JSON.stringify(initSettings));
};
// ** Create Context
const SettingsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    saveSettings: ()=>null,
    settings: initialSettings
});
const SettingsProvider = (param)=>{
    let { children , pageSettings  } = param;
    // ** State
    const [settings, setSettings] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        ...initialSettings
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const restoredSettings = restoreSettings();
        if (restoredSettings) {
            setSettings({
                ...restoredSettings
            });
        }
        if (pageSettings) {
            setSettings({
                ...settings,
                ...pageSettings
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageSettings
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (settings.layout === "horizontal" && settings.mode === "semi-dark") {
            saveSettings({
                ...settings,
                mode: "light"
            });
        }
        if (settings.layout === "horizontal" && settings.appBar === "hidden") {
            saveSettings({
                ...settings,
                appBar: "fixed"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings.layout
    ]);
    const saveSettings = (updatedSettings)=>{
        storeSettings(updatedSettings);
        setSettings(updatedSettings);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SettingsContext.Provider, {
        value: {
            settings,
            saveSettings
        },
        children: children
    });
};
const SettingsConsumer = SettingsContext.Consumer;


/***/ }),

/***/ 19550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5026);
// ** MUI Imports

// ** Util Import

const UseBgColor = ()=>{
    // ** Hooks
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return {
        primaryFilled: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main
        },
        primaryLight: {
            color: theme.palette.primary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.primary.main, 0.12)
        },
        secondaryFilled: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main
        },
        secondaryLight: {
            color: theme.palette.secondary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.secondary.main, 0.12)
        },
        successFilled: {
            color: theme.palette.success.contrastText,
            backgroundColor: theme.palette.success.main
        },
        successLight: {
            color: theme.palette.success.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.success.main, 0.12)
        },
        errorFilled: {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main
        },
        errorLight: {
            color: theme.palette.error.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.error.main, 0.12)
        },
        warningFilled: {
            color: theme.palette.warning.contrastText,
            backgroundColor: theme.palette.warning.main
        },
        warningLight: {
            color: theme.palette.warning.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.warning.main, 0.12)
        },
        infoFilled: {
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.info.main
        },
        infoLight: {
            color: theme.palette.info.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.info.main, 0.12)
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (UseBgColor);


/***/ }),

/***/ 51514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66136);


const useSettings = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__.SettingsContext);


/***/ }),

/***/ 59882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oS": function() { return /* binding */ formatDateToMonthShort; }
/* harmony export */ });
/* unused harmony exports formatDate, formatCreditCardNumber, formatExpirationDate, formatCVC */
/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */ // ** Checks if the passed date is today
const isToday = (date)=>{
    const today = new Date();
    return new Date(date).getDate() === today.getDate() && new Date(date).getMonth() === today.getMonth() && new Date(date).getFullYear() === today.getFullYear();
};
const formatDate = function(value) {
    let formatting = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        month: "short",
        day: "numeric",
        year: "numeric"
    };
    if (!value) return value;
    return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ** Returns short month of passed date
const formatDateToMonthShort = function(value) {
    let toTimeForCurrentDay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const date = new Date(value);
    let formatting = {
        month: "short",
        day: "numeric"
    };
    if (toTimeForCurrentDay && isToday(date)) {
        formatting = {
            hour: "numeric",
            minute: "numeric"
        };
    }
    return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ? The following functions are taken from https://codesandbox.io/s/ovvwzkzry9?file=/utils.js for formatting credit card details
// Get only numbers from the input value
const clearNumber = function() {
    let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return value.replace(/\D+/g, "");
};
// Format credit cards according to their types
const formatCreditCardNumber = (value, Payment)=>{
    if (!value) {
        return value;
    }
    const issuer = Payment.fns.cardType(value);
    const clearValue = clearNumber(value);
    let nextValue;
    switch(issuer){
        case "amex":
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 10), " ").concat(clearValue.slice(10, 15));
            break;
        case "dinersclub":
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 10), " ").concat(clearValue.slice(10, 14));
            break;
        default:
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 8), " ").concat(clearValue.slice(8, 12), " ").concat(clearValue.slice(12, 19));
            break;
    }
    return nextValue.trim();
};
// Format expiration date in any credit card
const formatExpirationDate = (value)=>{
    const finalValue = value.replace(/^([1-9]\/|[2-9])$/g, "0$1/") // 3 > 03/
    .replace(/^(0[1-9]|1[0-2])$/g, "$1/") // 11 > 11/
    .replace(/^([0-1])([3-9])$/g, "0$1/$2") // 13 > 01/3
    .replace(/^(0?[1-9]|1[0-2])([0-9]{2})$/g, "$1/$2") // 141 > 01/41
    .replace(/^([0]+)\/|[0]+$/g, "0") // 0/ > 0 and 00 > 0
    // To allow only digits and `/`
    .replace(/[^\d\/]|^[\/]*$/g, "").replace(/\/\//g, "/") // Prevent entering more than 1 `/`
    ;
    return finalValue;
};
// Format CVC in any credit card
const formatCVC = (value, cardNumber, Payment)=>{
    const clearValue = clearNumber(value);
    const issuer = Payment.fns.cardType(cardNumber);
    const maxLength = issuer === "amex" ? 4 : 3;
    return clearValue.slice(0, maxLength);
};


/***/ }),

/***/ 83552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getInitials; }
/* harmony export */ });
// ** Returns initials from string
const getInitials = (string)=>string.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "");


/***/ }),

/***/ 5026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ hexToRGBA; }
/* harmony export */ });
/**
 ** Hex color to RGBA color
 */ const hexToRGBA = (hexCode, opacity)=>{
    let hex = hexCode.replace("#", "");
    if (hex.length === 3) {
        hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 96665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);




const NoData = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const [text, setText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [text2, setText2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [href, setHref] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [hrefText, setHrefText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const path = window.location.pathname;
        if (path.indexOf("android") != -1) {
            if (path.indexOf("android/local") != -1) {
                setText(t("If there is no data for only some of the features please go to the"));
                setText2(t("page to check Also the app cant track social media data before connection so please be patient if the app is fully authorized"));
                setHrefText(t("Permission check"));
                setHref("".concat("https://test-ms-dashboard.gbyte.com.cn", "/android/local/permission-check"));
                ;
            } else {
                setText(t("Please enable Google backup See"));
                setText2(t("for details"));
                setHrefText(t("here"));
            // if (locale && locale != 'en') {
            //   setHref(
            //     '/guide/back-up-android' + '-' + (locale == 'it-ch' ? 'it' : locale)
            //   )
            // } else {
            //   setHref('/guide/back-up-android')
            // }
            }
        } else {
            setText(t("Please enable iCloud backup See"));
            setText2(t("for details"));
            setHrefText(t("here"));
        // if (locale && locale != 'en') {
        //   setHref('/guide/back-up-ios' + '-' + (locale == 'it-ch' ? 'it' : locale))
        // } else {
        //   setHref('/guide/back-up-ios')
        // }
        }
    }, [
        locale,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "!h-[calc(var(--vh2)*100-240px)] smj:!h-[calc(var(--vh2)*100-115px)] w-full mt-5 [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white flex justify-center items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center px-2",
                children: [
                    t("It appears theres no data to show here yet"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("If data exists it may take up to 1 hour to download and appear"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("We suggest checking back in a little while")
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 30152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Config
 * -------------------------------------------------------------------------------------
 * ! IMPORTANT: Make sure you clear the browser local storage in order to see the config changes in the template.
 * ! To clear local storage, you may refer https://www.leadshook.com/help/how-to-clear-local-storage-in-google-chrome-browser/.
 */ const themeConfig = {
    // ** Layout Configs
    templateName: "Msafely" /* App Name */ ,
    layout: "vertical" /* vertical | horizontal */ ,
    mode: "light" /* light | dark | semi-dark /*! Note: semi-dark value will only work for Vertical Layout */ ,
    direction: "ltr" /* ltr | rtl */ ,
    skin: "default" /* default | bordered */ ,
    contentWidth: "boxed" /* full | boxed */ ,
    footer: "static" /* fixed | static | hidden */ ,
    // ** Routing Configs
    routingLoader: false,
    // ** Navigation (Menu) Configs
    navHidden: false,
    menuTextTruncate: true,
    navSubItemIcon: "mdi:circle" /* Icon */ ,
    verticalNavToggleType: "accordion" /* accordion | collapse /*! Note: This is for Vertical navigation menu only */ ,
    navCollapsed: false,
    navigationSize: 300 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    collapsedNavigationSize: 68 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    afterVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    beforeVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    horizontalMenuToggle: "hover" /* click | hover /*! Note: This is for Horizontal navigation menu only */ ,
    horizontalMenuAnimation: true,
    // ** AppBar Configs
    appBar: "fixed" /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */ ,
    appBarBlur: true,
    // ** Other Configs
    responsiveFontSizes: true,
    disableRipple: false,
    disableCustomizer: false,
    toastPosition: "top-right" /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */ 
};
/* harmony default export */ __webpack_exports__["default"] = (themeConfig);


/***/ }),

/***/ 77332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_facebook; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box_Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/apps/facebook/index.js
var facebook = __webpack_require__(17021);
// EXTERNAL MODULE: ./src/@core/hooks/useSettings.js
var useSettings = __webpack_require__(51514);
// EXTERNAL MODULE: ./src/@core/utils/get-initials.js
var get_initials = __webpack_require__(83552);
// EXTERNAL MODULE: ./src/@core/utils/format.js
var format = __webpack_require__(59882);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(19529);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(46483);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js + 1 modules
var ListItemAvatar = __webpack_require__(18987);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/react-perfect-scrollbar/lib/index.js
var lib = __webpack_require__(51964);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
// EXTERNAL MODULE: ./src/components/NoData/index.js
var NoData = __webpack_require__(96665);
;// CONCATENATED MODULE: ./src/@core/components/facebook/facebook-side-bar.js
// ** React Imports


// ** Next Import

// ** MUI Imports













// ** Third Party Components

// ** Icon Imports

// ** Custom Components Import
// ** Chat App Components Imports



const ScrollWrapper = (param)=>{
    let { children , hidden  } = param;
    if (hidden) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                height: "100%",
                overflow: "auto"
            },
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            options: {
                wheelPropagation: false
            },
            children: children
        });
    }
};
const callData = [
    {
        id: 1,
        name: "Harry",
        number: 6163566375
    }
];
const LineSideBar = (props)=>{
    // ** Props
    const { store , hidden , mdAbove , dispatch , userStatus , selectMessage , getInitials , sidebarWidth , setUserStatus , leftSidebarOpen , removeSelectedChat , userProfileLeftOpen , formatDateToMonthShort , handleLeftSidebarToggle , handleUserProfileLeftSidebarToggle , calls , setCalls , headImg , setHaedImg , setChat , setContacts , chat  } = props;
    // ** States
    const [query, setQuery] = (0,react.useState)("");
    const [filteredChat, setFilteredChat] = (0,react.useState)([]);
    const [filteredContacts, setFilteredContacts] = (0,react.useState)([]);
    const [active, setActive] = (0,react.useState)(null);
    // ** Hooks
    const router = (0,next_router.useRouter)();
    const handleChatClick = (type, id)=>{
        dispatch(selectMessage(id));
        setActive({
            type,
            id
        });
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const hasActiveId = (id)=>{
        if (store.chats !== null) {
            const arr = store.chats.filter((i)=>i.id === id);
            return !!arr.length;
        }
    };
    const ListHandler = (item)=>{
        setChat(true);
        setCalls(false);
        setContacts(false);
        setHaedImg(item.avatres);
    };
    const contactsHandler = ()=>{
        setChat(false);
        setCalls(false);
        setContacts(true);
    };
    const renderChats = ()=>{
        if (store && store.list && store.list.length) {
            let data = [];
            if (query.length > 0 && filteredChat.length > 0) {
                data = filteredChat;
            } else {
                data = store.list;
            }
            return data.map((item, index)=>{
                let a = index + 1;
                if (a < 10) {
                    a = "0" + a;
                }
                let t = "2022-" + a + "-" + a;
                const lastMessage = {
                    time: t,
                    message: ""
                };
                const activeCondition = active !== null && active.id === item.id && active.type === "messages";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    disablePadding: true,
                    sx: {
                        "&:not(:last-child)": {
                            mb: 1.5
                        }
                    },
                    onClick: ()=>ListHandler(item),
                    className: " border-opacity-40",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                        onClick: ()=>handleChatClick("messages", item.id),
                        sx: {
                            px: 1.5,
                            py: 1.5,
                            width: "100%",
                            borderRadius: 1,
                            alignItems: "flex-start",
                            ...activeCondition && {
                                backgroundColor: (theme)=>"#453E54"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                                sx: {
                                    m: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                    overlap: "circular",
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "right"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: item.avatres,
                                        sx: {
                                            width: 38,
                                            height: 38,
                                            outline: (theme)=>"2px solid ".concat(activeCondition ? theme.palette.common.white : "transparent")
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                sx: {
                                    my: 0,
                                    ml: 4,
                                    mr: 1.5
                                },
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            sx: {
                                                color: "white",
                                                fontWeight: 600,
                                                fontSize: 13
                                            },
                                            children: item.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "overflow-clip h-[20px] w-[220px] sm:w-[140px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-white text-opacity-60 text-[12px]",
                                                children: item.chat
                                            })
                                        })
                                    ]
                                }),
                                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    noWrap: true,
                                    variant: "body2",
                                    sx: {
                                        ...!activeCondition && {
                                            color: "text.disabled"
                                        }
                                    },
                                    children: lastMessage ? lastMessage.message : null
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "flex-end",
                                    flexDirection: "column",
                                    justifyContent: "flex-start"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-white text-[0.5rem]",
                                    children: item.time
                                })
                            })
                        ]
                    })
                }, index);
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    sx: {
                        color: "text.secondary"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData/* default */.Z, {})
                })
            });
        }
    };
    const handleFilter = (e)=>{
        setQuery(e.target.value);
        if (store.list !== null && store.list.length > 0) {
            const filteredChatsArr = store.list.filter((item)=>{
                return item.name.indexOf(e.target.value) >= 0;
            });
            setFilteredChat(filteredChatsArr);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
            open: leftSidebarOpen,
            onClose: handleLeftSidebarToggle,
            variant: mdAbove ? "permanent" : "temporary",
            ModalProps: {
                disablePortal: true,
                keepMounted: true // Better open performance on mobile.
            },
            sx: {
                zIndex: 7,
                height: "100%",
                display: "block",
                position: mdAbove ? "static" : "absolute",
                "& .MuiDrawer-paper": {
                    boxShadow: "none",
                    overflow: "hidden",
                    width: sidebarWidth,
                    position: mdAbove ? "static" : "absolute",
                    borderTopLeftRadius: (theme)=>theme.shape.borderRadius,
                    borderBottomLeftRadius: (theme)=>theme.shape.borderRadius
                },
                "& > .MuiBackdrop-root": {
                    borderRadius: 1,
                    position: "absolute",
                    zIndex: (theme)=>theme.zIndex.drawer - 1
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-[#160C2F] h-[70px] flex items-center w-full justify-between border-white border-opacity-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/call-log/8.webp",
                                width: 38,
                                height: 38,
                                className: "rounded-full ml-3",
                                alt: "Call-log"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-[17px] font-medium -ml-2 text-white",
                                children: "Messenger"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mr-4 cursor-pointer flex ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: contactsHandler,
                                className: "text-white text-opacity-95",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                    icon: "mingcute:contacts-fill",
                                    width: 25,
                                    height: 25,
                                    style: {
                                        color: chat === false ? "white" : ""
                                    }
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        height: "calc(100% - 4.125rem)",
                        backgroundColor: "#160C2F"
                    },
                    className: "border-r-[1px] border-black border-opacity-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
                        hidden: hidden,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                p: (theme)=>theme.spacing(2, 3, 3)
                            },
                            children: [
                                !mdAbove ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                    sx: {
                                        p: 1,
                                        ml: 1,
                                        mt: 4
                                    },
                                    onClick: handleLeftSidebarToggle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "mdi:close",
                                        fontSize: "1.375rem"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                    sx: {
                                        mb: 7.5,
                                        p: 0,
                                        mt: 4
                                    },
                                    className: "",
                                    children: renderChats()
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var facebook_side_bar = (LineSideBar);

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./src/@core/components/mui/avatar/index.js
var avatar = __webpack_require__(92024);
;// CONCATENATED MODULE: ./src/@core/components/facebook/facebook-log.js
// ** React Imports


// ** MUI Imports



// ** Third Party Components



const PerfectScrollbar = (0,styled/* default */.ZP)((lib_default()))((param)=>{
    let { theme  } = param;
    return {
        padding: theme.spacing(5)
    };
});
const MessagesLog = (props)=>{
    // ** Props
    const { data , hidden  } = props;
    // ** Ref
    const chatArea = (0,react.useRef)(null);
    // ** Scroll to chat bottom
    const scrollToBottom = ()=>{
        if (chatArea.current) {
            if (hidden) {
                // @ts-ignore
                chatArea.current.scrollTop = Number.MAX_SAFE_INTEGER;
            } else {
                // @ts-ignore
                chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER;
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (data && data.chat && data.chat.length) {
            scrollToBottom();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    // ** Renders user chat
    const renderChats = ()=>{
        return data.chat.chat.map((item, index)=>{
            const isSender = item.isFromMe;
            const time = new Date(item.date).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: !item.isFromMe ? "row" : "row-reverse"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                            skin: "light",
                            sx: {
                                width: "1.8rem",
                                height: "1.8rem",
                                fontSize: "0.875rem",
                                ml: isSender ? 4 : undefined,
                                mr: !isSender ? 4 : undefined
                            },
                            ...data.chat.contact.avatar && !isSender ? {
                                src: data.chat.contact.avatar
                            } : {},
                            ...isSender ? {
                                src: "/images/call-log/8.webp"
                            } : {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: "chat-body",
                        sx: {
                            maxWidth: [
                                "calc(100% - 5.75rem)",
                                "75%",
                                "65%"
                            ],
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                "&:not(:last-of-type)": {
                                    mb: 3.5
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    sx: {
                                        boxShadow: 1,
                                        borderRadius: 1,
                                        width: "fit-content",
                                        p: (theme)=>theme.spacing(0, 2),
                                        ml: isSender ? "auto" : undefined,
                                        borderTopLeftRadius: !isSender ? 0 : undefined,
                                        borderTopRightRadius: isSender ? 0 : undefined,
                                        color: isSender ? "black" : "text.primary",
                                        backgroundColor: isSender ? "#19A2FF" : "#303030",
                                        mb: 3
                                    },
                                    children: typeof item.img === "undefined" || item.img === "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " flex p-2 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[0.7rem] text-white ",
                                                children: item.text
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.img,
                                        alt: "Picture of the author",
                                        width: 150,
                                        height: 150
                                    })
                                })
                            })
                        }, index)
                    })
                ]
            }, index);
        });
    };
    const ScrollWrapper = (param)=>{
        let { children  } = param;
        if (hidden) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                ref: chatArea,
                sx: {
                    p: 5,
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden"
                },
                children: children
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PerfectScrollbar, {
                ref: chatArea,
                options: {
                    wheelPropagation: false
                },
                children: children
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            height: "calc(100% - 8.4375rem)"
        },
        className: "bg-[#120A28] mt-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
            children: renderChats()
        })
    });
};
/* harmony default export */ var facebook_log = (MessagesLog);

;// CONCATENATED MODULE: ./src/@core/components/facebook/facebook-content.js
// ** React Imports


// ** MUI Imports





// ** Icon Imports

// ** Custom Components Import


// ** Styled Components
const ChatWrapperStartChat = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const KikContent = (props)=>{
    // ** Props
    const { data , store , hidden , sendMsg , mdAbove , dispatch , getInitials , sidebarWidth , userProfileRightOpen , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle , headImg  } = props;
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (store) {
            const selectedMessage = store.selectedMessage;
            if (!selectedMessage) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatWrapperStartChat, {
                    sx: {
                        ...mdAbove ? {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0
                        } : {}
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        onClick: handleStartConversation,
                        sx: {
                            px: 6,
                            py: 2.25,
                            boxShadow: 3,
                            borderRadius: 5,
                            backgroundColor: "background.paper",
                            cursor: mdAbove ? "default" : "pointer"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            sx: {
                                fontWeight: 600
                            },
                            children: "Start Conversation"
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#120A28"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                py: 3,
                                px: 5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider),
                                backgroundColor: "#120A28",
                                height: 50
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                className: "sm:w-full ",
                                children: [
                                    mdAbove ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                        onClick: handleLeftSidebarToggle,
                                        sx: {
                                            mr: 2,
                                            color: "white"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:menu"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        onClick: handleUserProfileRightSidebarToggle,
                                        sx: {
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            sx: {
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            className: "flex items-center mt-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: headImg,
                                                        alt: "img",
                                                        width: 38,
                                                        height: 38,
                                                        className: " rounded-full"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ml-2 font-bold text-[14px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "text-white",
                                                            children: selectedMessage.chat.contact.fullName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "text-[12px] font-normal text-white text-opacity-80",
                                                            children: selectedMessage.chat.contact.label
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                ]
                            })
                        }),
                        selectedMessage && store.userProfile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_log, {
                            hidden: hidden,
                            data: {
                                ...selectedMessage
                            }
                        }) : null
                    ]
                });
            }
        } else {
            return null;
        }
    };
    return renderContent();
};
/* harmony default export */ var facebook_content = (KikContent);

;// CONCATENATED MODULE: ./src/@core/components/facebook/facebook-call.js





// ** Icon Imports


// ** Styled Components
const facebook_call_ChatWrapperStartChat = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const TextMessagesContent = (props)=>{
    // ** Props
    const { data , store , hidden , sendMsg , mdAbove , dispatch , getInitials , sidebarWidth , callData , userProfileRightOpen , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle  } = props;
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (store) {
            const selectedMessage = store.selectedMessage;
            if (!selectedMessage) {
                return /*#__PURE__*/ _jsx(facebook_call_ChatWrapperStartChat, {
                    sx: {
                        ...mdAbove ? {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0
                        } : {}
                    },
                    children: /*#__PURE__*/ _jsx(Box, {
                        onClick: handleStartConversation,
                        sx: {
                            px: 6,
                            py: 2.25,
                            boxShadow: 3,
                            borderRadius: 5,
                            backgroundColor: "background.paper",
                            cursor: mdAbove ? "default" : "pointer"
                        },
                        children: /*#__PURE__*/ _jsx(Typography, {
                            sx: {
                                fontWeight: 600
                            },
                            children: "Start Conversation"
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsxs(Box, {
                        sx: {
                            flexGrow: 1,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "h-[20px] bg-[#f1f3f5]"
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                sx: {
                                    py: 3,
                                    px: 5,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider),
                                    backgroundColor: "#f1f3f5",
                                    height: 50
                                },
                                className: "border-b-[1px] border-t",
                                children: /*#__PURE__*/ _jsxs(Box, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        mdAbove ? null : /*#__PURE__*/ _jsx(IconButton, {
                                            onClick: handleLeftSidebarToggle,
                                            sx: {
                                                mr: 2
                                            },
                                            children: /*#__PURE__*/ _jsx(Icon, {
                                                icon: "mdi:menu"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            onClick: handleUserProfileRightSidebarToggle,
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ _jsx(Box, {
                                                sx: {
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                                children: /*#__PURE__*/ _jsx(Typography, {
                                                    sx: {
                                                        color: "text.secondary",
                                                        fontWeight: 700,
                                                        color: "black"
                                                    },
                                                    children: "Calls"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "overflow-auto h-[90%] bg-white",
                                children: callData.calls.map((item)=>{
                                    return /*#__PURE__*/ _jsxs("div", {
                                        className: "w-9/12 mx-auto flex justify-between items-center mt-6 border-b-[1px] border-[#f3f5f9] ",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center p-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "w-[40px] rounded-full",
                                                        children: /*#__PURE__*/ _jsx(Image, {
                                                            src: item.img,
                                                            alt: "img",
                                                            width: 100,
                                                            height: 40,
                                                            className: " rounded-full"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "ml-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                children: /*#__PURE__*/ _jsx("h2", {
                                                                    className: "text-[15px] text-[#53a2ec] font-semibold",
                                                                    children: item.name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "flex mt-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        children: /*#__PURE__*/ _jsx(Icon, {
                                                                            icon: item.icon,
                                                                            className: "text-blue-500",
                                                                            width: 15,
                                                                            style: {
                                                                                color: item.state === -1 ? "red" : ""
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        children: /*#__PURE__*/ _jsx("h2", {
                                                                            className: "text-[12px] ml-2 text-[#4d5976] font-medium text-opacity-80",
                                                                            children: item.time
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx("h2", {
                                                    className: "text-[13px] font-bold text-black text-opacity-60",
                                                    children: item.Time
                                                })
                                            })
                                        ]
                                    }, item.id);
                                })
                            })
                        ]
                    })
                });
            }
        } else {
            return null;
        }
    };
    return renderContent();
};
/* harmony default export */ var facebook_call = ((/* unused pure expression or super */ null && (TextMessagesContent)));

;// CONCATENATED MODULE: ./src/@core/components/facebook/facebook-contacts.js





// ** Icon Imports


// ** Styled Components
const facebook_contacts_ChatWrapperStartChat = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const WhatsappContacts = (props)=>{
    // ** Props
    const { data , store , hidden , sendMsg , mdAbove , dispatch , getInitials , sidebarWidth , callData , userProfileRightOpen , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle , setContacts  } = props;
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (store) {
            const selectedMessage = store.selectedMessage;
            if (!selectedMessage) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_contacts_ChatWrapperStartChat, {
                    sx: {
                        ...mdAbove ? {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0
                        } : {}
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        onClick: handleStartConversation,
                        sx: {
                            px: 6,
                            py: 2.25,
                            boxShadow: 3,
                            borderRadius: 5,
                            backgroundColor: "background.paper",
                            cursor: mdAbove ? "default" : "pointer"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            sx: {
                                fontWeight: 600
                            },
                            children: "Start Conversation"
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            flexGrow: 1,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#160C2F"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    py: 3,
                                    px: 5,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider),
                                    backgroundColor: "#160C2F",
                                    height: 70
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        mdAbove ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            onClick: handleLeftSidebarToggle,
                                            sx: {
                                                mr: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                icon: "mdi:menu"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                            onClick: handleUserProfileRightSidebarToggle,
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    sx: {
                                                        color: "text.secondary",
                                                        fontWeight: 700,
                                                        color: "white"
                                                    },
                                                    children: "Contacts"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "overflow-auto h-[90%] bg-[#160C2F]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-4 gap-y-4 w-11/12 mx-auto mt-4 sm:grid-cols-2",
                                    children: callData.contacts.map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "bg-[#F3F4F6] rounded-lg h-[130px] w-5/6 items-center grid shadow-2xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: item.img,
                                                        alt: "img",
                                                        width: 55,
                                                        height: 55,
                                                        className: " rounded-full"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center justify-center text-[14px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "font-bold",
                                                        children: item.name
                                                    })
                                                })
                                            ]
                                        }, item.id);
                                    })
                                })
                            })
                        ]
                    })
                });
            }
        } else {
            return null;
        }
    };
    return renderContent();
};
/* harmony default export */ var facebook_contacts = (WhatsappContacts);

// EXTERNAL MODULE: ./src/components/ContentLoading/index.js
var ContentLoading = __webpack_require__(74743);
;// CONCATENATED MODULE: ./src/pages/facebook/index.js
// ** React Imports


// ** MUI Imports



// ** Store & Actions Imports


// ** Hooks

// ** Utils Imports


// ** Chat App Components Imports







const facebook_callData = {
    calls: [
        {
            id: 1,
            name: "Aiden",
            img: "/images/avatars/1.png",
            icon: "fluent:call-inbound-16-filled",
            time: "Nov 11, 08:41 pm",
            Time: "19s",
            state: -1
        },
        {
            id: 2,
            name: "Jacob ",
            img: "/images/avatars/2.png",
            icon: "fluent:call-inbound-16-filled",
            time: "Nov 11, 08:41 pm",
            Time: "19s",
            state: -1
        },
        {
            id: 3,
            name: "Ethan ",
            img: "/images/avatars/3.png",
            icon: "fluent:call-outbound-16-filled",
            time: "Nov 11, 08:41 pm",
            Time: "40s",
            state: 1
        },
        {
            id: 4,
            name: "Caden ",
            img: "/images/avatars/4.png",
            icon: "fluent:call-inbound-16-filled",
            time: "Nov 11, 08:39 pm",
            Time: "20s",
            state: -1
        },
        {
            id: 5,
            name: "Jackson ",
            img: "/images/avatars/5.png",
            icon: "fluent:call-inbound-16-filled",
            time: "Nov 11, 08:25 pm",
            Time: "34s",
            state: -1
        },
        {
            id: 6,
            name: "Smith ",
            img: "/images/avatars/6.png",
            icon: "fluent:call-outbound-16-filled",
            time: "Nov 11, 08:10 pm",
            Time: "19s",
            state: 1
        },
        {
            id: 7,
            name: "Smith",
            img: "/images/avatars/6.png",
            icon: "fluent:call-outbound-16-filled",
            time: "Nov 11, 08:12 pm",
            Time: "41s",
            state: 1,
            State: false
        },
        {
            id: 8,
            name: "Sammy ",
            img: "/images/avatars/8.png",
            icon: "fluent:call-outbound-16-filled",
            time: "Nov 11, 07:41 pm",
            Time: "59s",
            state: 1
        },
        {
            id: 9,
            name: "Jacob",
            img: "/images/avatars/2.png",
            icon: "fluent:call-outbound-16-filled",
            time: "Nov 11, 07:00 pm",
            Time: "10s",
            state: 1
        },
        {
            id: 10,
            name: "Jackson",
            img: "/images/call-log/5.webp",
            icon: "fluent:call-inbound-16-filled",
            time: "Nov 11, 05:00 pm",
            Time: "45s",
            state: -1
        },
        {
            id: 11,
            name: "Aiden",
            img: "/images/avatars/1.png",
            icon: "fluent:call-outbound-16-filled",
            time: "Nov 11, 04:50 pm",
            Time: "1m 25s",
            state: 1
        }
    ],
    contacts: [
        {
            id: 1,
            name: "Sarah",
            img: "/images/avatars/2.png"
        },
        {
            id: 2,
            name: "Jacob",
            img: "/images/avatars/2.png"
        },
        {
            id: 3,
            name: "Ethan",
            img: "/images/avatars/3.png"
        },
        {
            id: 4,
            name: "Caden",
            img: "/images/avatars/4.png"
        },
        {
            id: 5,
            name: "Jackson",
            img: "/images/avatars/5.png"
        },
        {
            id: 6,
            name: "Smith",
            img: "/images/avatars/6.png"
        },
        {
            id: 7,
            name: "Johny",
            img: "/images/avatars/7.png"
        },
        {
            id: 8,
            name: "Sammy",
            img: "/images/avatars/8.png"
        },
        {
            id: 9,
            name: "Olivia",
            img: "/images/call-log/2.webp"
        },
        {
            id: 11,
            name: "Aiden",
            img: "/images/avatars/1.png"
        },
        {
            id: 12,
            name: "Billie",
            img: "/images/call-log/4.webp"
        },
        {
            id: 13,
            name: "Green",
            img: "/images/call-log/8.webp"
        },
        {
            id: 14,
            name: "Cameron",
            img: "/images/avatars/4.png"
        },
        {
            id: 15,
            name: "+6180650048",
            img: "/images/avatars/5.png"
        },
        {
            id: 16,
            name: "+6176429832",
            img: "/images/avatars/6.png"
        },
        {
            id: 17,
            name: "+6145575780",
            img: "/images/avatars/7.png"
        },
        {
            id: 18,
            name: "+6105280088",
            img: "/images/avatars/8.png"
        },
        {
            id: 19,
            name: "Sarah",
            img: "/images/avatars/2.png"
        },
        {
            id: 21,
            name: "Rebecca",
            img: "/images/call-log/11.webp"
        },
        {
            id: 22,
            name: "Amy",
            img: "/images/avatars/1.png"
        }
    ]
};
const Facebook = ()=>{
    // ** States
    const [userStatus, setUserStatus] = (0,react.useState)("online");
    const [leftSidebarOpen, setLeftSidebarOpen] = (0,react.useState)(false);
    const [userProfileLeftOpen, setUserProfileLeftOpen] = (0,react.useState)(false);
    const [userProfileRightOpen, setUserProfileRightOpen] = (0,react.useState)(false);
    // ** Hooks
    const theme = (0,useTheme/* default */.Z)();
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const hidden = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const store = (0,es/* useSelector */.v9)((state)=>state.Facebook);
    // ** Vars
    const { skin  } = settings;
    const smAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const sidebarWidth = smAbove ? 370 : 300;
    const mdAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    const [chat, setChat] = (0,react.useState)(true);
    const [calls, setCalls] = (0,react.useState)(false);
    const [headImg, setHaedImg] = (0,react.useState)("/images/avatars/1.png");
    const [contacts, setContacts] = (0,react.useState)(false);
    const [fetchLoading, setFetchLoading] = (0,react.useState)(true);
    const callHandler = ()=>{
        setChat(false);
        setContacts(false);
        setCalls(true);
    };
    const contactsHandler = ()=>{
        setChat(false);
        setCalls(false);
        setContacts(true);
    };
    const ChatHandler = ()=>{
        setChat(true);
        setCalls(false);
        setContacts(false);
    };
    (0,react.useEffect)(()=>{
        Promise.allSettled([
            dispatch((0,facebook/* fetchUserProfile */.YI)()),
            dispatch((0,facebook/* fetchChatsContacts */.Pu)())
        ]).finally(()=>{
            setFetchLoading(false);
        });
    }, [
        dispatch
    ]);
    const handleLeftSidebarToggle = ()=>setLeftSidebarOpen((prev)=>!prev);
    const handleUserProfileLeftSidebarToggle = ()=>setUserProfileLeftOpen((prev)=>!prev);
    const handleUserProfileRightSidebarToggle = ()=>setUserProfileRightOpen((prev)=>!prev);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            className: "app-chat",
            sx: {
                width: "100%",
                display: "flex",
                borderRadius: 1,
                position: "relative",
                minHeight: "calc(var(--vh2) * 100 - 90px)",
                boxShadow: skin === "bordered" ? 0 : 6,
                ...skin === "bordered" && {
                    border: "1px solid ".concat(theme.palette.divider)
                }
            },
            children: fetchLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLoading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_side_bar, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        userStatus: userStatus,
                        selectMessage: facebook/* selectMessage */.rT,
                        getInitials: get_initials/* getInitials */.Q,
                        sidebarWidth: sidebarWidth,
                        setUserStatus: setUserStatus,
                        leftSidebarOpen: leftSidebarOpen,
                        removeSelectedChat: facebook/* removeSelectedChat */.sr,
                        userProfileLeftOpen: userProfileLeftOpen,
                        formatDateToMonthShort: format/* formatDateToMonthShort */.oS,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileLeftSidebarToggle: handleUserProfileLeftSidebarToggle,
                        calls: calls,
                        setCalls: setCalls,
                        headImg: headImg,
                        setChat: setChat,
                        chat: chat,
                        setHaedImg: setHaedImg,
                        setContacts: setContacts
                    }),
                    chat && /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_content, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        getInitials: get_initials/* getInitials */.Q,
                        sidebarWidth: sidebarWidth,
                        userProfileRightOpen: userProfileRightOpen,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                        headImg: headImg,
                        setHaedImg: setHaedImg
                    }),
                    chat === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_contacts, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        getInitials: get_initials/* getInitials */.Q,
                        sidebarWidth: sidebarWidth,
                        userProfileRightOpen: userProfileRightOpen,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                        setCalls: setCalls,
                        headImg: headImg,
                        setHaedImg: setHaedImg,
                        setContacts: setContacts,
                        callData: facebook_callData
                    }) : ""
                ]
            })
        })
    });
};
Facebook.contentHeightFixed = true;
/* harmony default export */ var pages_facebook = (Facebook);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1954,518,2607,6664,8863,1964,6853,7891,1558,9774,2888,179], function() { return __webpack_exec__(99589); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);